import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { UserCheckIcon, Loader2Icon } from 'lucide-react';
import { useLanguage } from './LanguageContext';
import { useAssociateStatus } from './AssociateStatusContext';
export function AssociateStatusBubble() {
  const {
    status
  } = useAssociateStatus();
  const {
    t
  } = useLanguage();
  return <AnimatePresence data-id="element-22">
      {status === 'requesting' && <motion.div key="requesting" initial={{
      opacity: 0,
      y: -8
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -8
    }} className="mx-4 my-3" data-id="element-23">
          <motion.div animate={{
        boxShadow: ['0 0 0 0 rgba(250, 204, 21, 0.45)', '0 0 0 10px rgba(250, 204, 21, 0)']
      }} transition={{
        repeat: Infinity,
        duration: 1.4,
        ease: 'easeOut'
      }} className="flex items-center gap-2.5 px-3.5 py-2 rounded-full bg-yellow-50 border border-yellow-300 text-yellow-900 text-xs font-semibold w-fit" data-id="element-24">
            <motion.span animate={{
          rotate: 360
        }} transition={{
          repeat: Infinity,
          duration: 1,
          ease: 'linear'
        }} className="inline-flex" data-id="element-25">
              <Loader2Icon size={14} data-id="element-26" />
            </motion.span>
            {t('associate.requesting')}
          </motion.div>
        </motion.div>}
      {status === 'confirmed' && <motion.div key="confirmed" initial={{
      opacity: 0,
      y: -8
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -8
    }} className="mx-4 my-3" data-id="element-27">
          <motion.div animate={{
        boxShadow: ['0 0 0 0 rgba(34, 197, 94, 0.45)', '0 0 0 10px rgba(34, 197, 94, 0)']
      }} transition={{
        repeat: Infinity,
        duration: 1.6,
        ease: 'easeOut'
      }} className="flex items-center gap-2 px-3.5 py-2 rounded-full bg-green-50 border border-green-300 text-green-800 text-xs font-semibold w-fit" data-id="element-28">
            <UserCheckIcon size={14} data-id="element-29" />
            {t('associate.onTheWay')}
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}